"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../utils");
var _photographyClientLib = require("@wix/photography-client-lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var FullscreenCheckoutLink = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FullscreenCheckoutLink, _React$Component);
  function FullscreenCheckoutLink() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = FullscreenCheckoutLink.prototype;
  _proto.getLinkText = function getLinkText(count) {
    return _photographyClientLib.translationUtils.getByKey('Gallery_ArtStore_UOU_Continue_Checkout_Label') + (" (" + count + ")");
  };
  _proto.render = function render() {
    var _this$props = this.props,
      _onClick = _this$props.onClick,
      cartItemsCount = _this$props.cartItemsCount;
    return cartItemsCount ? /*#__PURE__*/_react["default"].createElement("button", {
      className: "pro-fullscreen-checkout-link",
      onClick: function onClick() {
        return _onClick();
      },
      tabIndex: _utils.utils.getTabIndex('fullscreenCheckout'),
      "aria-label": this.getLinkText(cartItemsCount)
    }, this.getLinkText(cartItemsCount)) : null;
  };
  return FullscreenCheckoutLink;
}(_react["default"].Component);
var _default = FullscreenCheckoutLink;
exports["default"] = _default;